import { Box, Grid, Paper, Tab, Tabs } from '@mui/material';
import React, {useContext, useState} from "react";
import AttributesDataTable from "./AttributesDataTable";
import i18next from "i18next";
import EATabPanel from "../../../components/common/EATabPanel";
import useStyles from "../../../style/js-style/containers/administration/attributes/AttributesStyle";
import {PrivilegeEnum, RoleBasedAccessControlContext} from "../../../services/common/RolesUtils";

function Attributes() {
  const { classes } = useStyles();
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);
  const [selectedTab, setSelectedTab] = useState(() => {
    if (hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_ATTRIBUTE)) return 0;
    if (hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_ATTRIBUTE)) return 1;
    if (hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_PARTNER_ATTRIBUTE)) return 2;
  });

  const handleTabChange = (event, newValue) => setSelectedTab(newValue);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <Grid container justifyContent="space-evenly" spacing={0}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper elevation={0} style={{ marginTop: "17px" }}>

            {/* Tabs */}
            <Box className={classes.tabsWrapper} sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                aria-label="attributs tabs"
              >
                < Tab
                  label={i18next.t("adminSettings.thirdpartyAttributes")}
                  {...a11yProps(0)}
                  className={classes.tab}
                  style={{position: "relative", top: "12px"}}
                  disabled={!hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_ATTRIBUTE)}
                />
                <Tab
                  label={i18next.t("adminSettings.dossierAttributes")}
                  {...a11yProps(1)}
                  className={classes.tab}
                  style={{position: "relative", top: "12px"}}
                  disabled={!hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_ATTRIBUTE)}
                />
                <Tab
                  label={i18next.t("adminSettings.partnerAttributes")}
                  {...a11yProps(2)}
                  className={classes.tab}
                  style={{position: "relative", top: "12px"}}
                  disabled={!hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_PARTNER_ATTRIBUTE)}
                />
              </Tabs>
            </Box>

            {/* ThirdParty tab */}
            {hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_ATTRIBUTE) &&
              <EATabPanel value={selectedTab} index={0} variant={"withoutBackground"}>
                <AttributesDataTable bondType={"thirdparty"}/>
              </EATabPanel>
            }

            {/* Dossier tab */}
            {hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_ATTRIBUTE) &&
              <EATabPanel value={selectedTab} index={1} variant={"withoutBackground"}>
                <AttributesDataTable bondType={"dossier"}/>
              </EATabPanel>
            }

            {/* Partners tab */}
            {hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_PARTNER_ATTRIBUTE) &&
              <EATabPanel value={selectedTab} index={2} variant={"withoutBackground"}>
                <AttributesDataTable />
              </EATabPanel>
            }

          </Paper>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Attributes;
